import React, {useEffect, useState} from 'react';
import Dots from 'assets/svgs/common/drag.svg';
import EditIcon from 'assets/svgs/actions/edit.svg';
import DeleteIcon from 'assets/svgs/actions/delete.svg';
import OutsideClickHandler from 'react-outside-click-handler';
import Check from 'assets/svgs/actions/check.svg';
import Clear from 'assets/svgs/actions/clear.svg';

const Labels = ({onChange, postLabel}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState({
    label: '',
    colour: '',
  });

  const [edit, setEdit] = useState(false);

  const defaultColor = [
    '#FF8982',
    '#FFBF66',
    `#FFF079`,
    `#68EBA9`,
    `#66F9F2`,
    `#9CDEFC`,
    `#79BFFC`,
    `#AEAFFF`,
    `#FC7095`,
    `#C1C6CC`,
  ];

  useEffect(() => {
    setSelected(postLabel);
  }, [postLabel]);

  const renderEdit = () => (
    <div className="d-flex flex-column px-2 mt-2">
      <input
        type="text"
        value={selected.label}
        onChange={(e) => {
          const newSelected = {...selected};
          newSelected.label = e.target.value;
          setSelected(newSelected);
        }}
      />
      <div className="w-100 d-flex justify-content-end">
        <button
          type="button"
          className="btn btn-small"
          onClick={() => {
            setEdit(false);
          }}
        >
          <img src={Clear} alt="" height="20px" />
        </button>
        <button
          type="button"
          className="btn btn-small"
          onClick={() => {
            setEdit(false);
            onChange(selected);
            setIsOpen(false);
          }}
        >
          <img alt="" height="15px" src={Check} />
        </button>
      </div>
    </div>
  );

  return (
    <>
      {postLabel && (
        <div className="role-btn text-center text-white mr-2  pointer">
          <span style={{background: selected.colour}}>{selected.label}</span>
        </div>
      )}

      <div className="lable-edit-dropdown">
        <img
          src={Dots}
          alt=""
          aria-hidden
          className="pointer"
          onClick={() => setIsOpen(!isOpen)}
        />
        {isOpen && (
          <OutsideClickHandler onOutsideClick={() => setIsOpen(false)}>
            <div className="position-absolute items-container d-flex flex-column bg-white">
              <div
                aria-hidden
                className="py-2 d-flex w-100 align-items-center"
                onClick={() => setEdit(true)}
              >
                <img src={EditIcon} alt="" className="mr-3 ml-4" height="13" />{' '}
                Edit
              </div>
              <hr />

              {edit ? (
                renderEdit()
              ) : (
                <div className="lables my-2">
                  {defaultColor.map((colour) => (
                    <div
                      aria-hidden
                      onClick={() => {
                        const newSelected = {...selected, colour};
                        setSelected(newSelected);
                        onChange(newSelected);
                      }}
                      className="color"
                      data-ping={selected.colour === colour}
                      style={{
                        backgroundColor: colour,
                        borderWidth: selected.colour === colour ? '3px' : '0px',
                      }}
                      key={colour}
                    ></div>
                  ))}
                </div>
              )}

              <hr />
              <div className="py-2 d-flex w-100 align-items-center text-delete pointer">
                <img
                  src={DeleteIcon}
                  alt=""
                  className="mr-3 ml-4"
                  height="13"
                />{' '}
                Delete
              </div>
            </div>
          </OutsideClickHandler>
        )}
      </div>
    </>
  );
};

export default Labels;
